var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[[_c('el-backtop'),(_vm.isLoaded && !_vm.$route.meta.isShowHeader)?_c('homeHeader'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }